var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.68 43.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cc020d;}.cls-2{fill:#e5e5e5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flags"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 75.68,
    height: 43.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.5,
    width: 38.68,
    height: 43.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.56,26.16c2.44-2,5.18-4.11,5.18-4.11A10.1,10.1,0,0,1,52.51,21c-.16-.3,1.58-5.81,1.58-5.81a40.5,40.5,0,0,1-5.25,1c-.43-.15-.92-2.47-.92-2.47s-4,4.84-4.86,4.4,1.49-9.49,1.49-9.49-2.2,1.35-3.11,1.29-3.6-5.78-3.6-5.78-2.69,5.71-3.6,5.78-3.1-1.29-3.1-1.29,2.39,9,1.48,9.49-4.85-4.4-4.85-4.4-.5,2.32-.92,2.47a40.5,40.5,0,0,1-5.25-1s1.73,5.51,1.57,5.81a10.1,10.1,0,0,1-2.23,1.07s2.75,2.15,5.18,4.11c1.64,1.32,3.29,2.55,3.27,3a24,24,0,0,1-.66,2.69l8.37-1a1.41,1.41,0,0,0,.17.28.8.8,0,0,0,.18.17s-.14,2.79-.14,3.9S37,39.77,37,39.77h1.6s-.26-3.45-.26-4.57-.15-3.9-.15-3.9a.8.8,0,0,0,.18-.17,1.85,1.85,0,0,0,.18-.28l8.36,1a22.28,22.28,0,0,1-.65-2.69C46.27,28.71,47.93,27.48,49.56,26.16Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/ca.226895fb.svg";
export { ForwardRef as ReactComponent };